window.addEventListener("load", function(){
  

  if( theme.countdown == 'true' && theme.event_date !== '' ){

    const countdown_div = document.createElement("div");
      countdown_div.classList.add('countdown-container', 'd-none');

      const countdown_register_div = document.createElement("div");
        countdown_register_div.classList.add('register', 'is-register-button');
        countdown_register_div.setAttribute('role','button');

        const countdown_register_text = document.createTextNode("Register");
        countdown_register_div.appendChild(countdown_register_text);

        

      const countdown_element = document.createElement("div");
      countdown_element.classList.add('countdown');

        // Day

        const countdown_day= document.createElement("div");
        countdown_day.classList.add('day');

          const countdown_day_number= document.createElement("span");
        countdown_day.appendChild(countdown_day_number);

        const countdown_day_text = document.createTextNode(" Days");
        countdown_day.appendChild(countdown_day_text);


        const countdown_hour= document.createElement("div");
        countdown_hour.classList.add('hour');

          const countdown_hour_number= document.createElement("span");
        countdown_hour.appendChild(countdown_hour_number);

        const countdown_hour_text = document.createTextNode("h:");
        countdown_hour.appendChild(countdown_hour_text);


        const countdown_minutes= document.createElement("div");
        countdown_minutes.classList.add('minutes');

          const countdown_minutes_number= document.createElement("span");
        countdown_minutes.appendChild(countdown_minutes_number);

        const countdown_minutes_text = document.createTextNode("m:");
        countdown_minutes.appendChild(countdown_minutes_text);


        const countdown_seconds= document.createElement("div");
        countdown_seconds.classList.add('seconds');

          const countdown_seconds_number= document.createElement("span");
        countdown_seconds.appendChild(countdown_seconds_number);


        const countdown_seconds_text = document.createTextNode("s");
        countdown_seconds.appendChild(countdown_seconds_text);

        countdown_element.appendChild(countdown_day);
        countdown_element.appendChild(countdown_hour);
        countdown_element.appendChild(countdown_minutes);
        countdown_element.appendChild(countdown_seconds);



      // Append to div
      countdown_div.appendChild(countdown_register_div);
      countdown_div.appendChild(countdown_element);
            

      // Add to body 
      document.body.append( countdown_div );   


      // Start the timer
    // Set the date we're counting down to
    var countDownDate = new Date(  theme.event_date ).getTime();

    // Update the count down every 1 second
    var x = setInterval(function() {

      // Get today's date and time
      var now = new Date( ).getTime();

      // Find the distance between now and the count down date
      var distance = countDownDate - now;

      // Time calculations for days, hours, minutes and seconds
      var days = Math.floor(distance / (1000 * 60 * 60 * 24));
      var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      var seconds = Math.floor((distance % (1000 * 60)) / 1000);

      // Display the result in the element with id="demo"

      countdown_day_number.textContent = days;
      countdown_hour_number.textContent = hours;
      countdown_minutes_number.textContent = minutes;
      countdown_seconds_number.textContent = seconds;

      countdown_div.classList.remove('d-none');

      // If the count down is finished, write some text
      if (distance < 0) {
        clearInterval(x);
        countdown_element.innerHTML = "EXPIRED";
        countdown_div.classList.add('d-none');

      }
    }, 1000);


  }
      
  
});